function swiperSlider() {
  const swiperContainers = document.querySelectorAll('[id^="section-id-"] .swiper-container');

  swiperContainers.forEach((swiperContainer, index) => {
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    if (slides.length === 0) {
      swiperContainer.style.display = 'none'; // Hide empty containers
      return;
    }

    const section = swiperContainer.closest('[id^="section-id-"]');
    new Swiper(swiperContainer, {
      slidesPerView: 2,
      spaceBetween: 24,
      loop: false,
      // scrollbar: {
      //   el: '.swiper-scrollbar',
      //   draggable: true,
      //   snapOnRelease: true,
      // },
      breakpoints: {
        0: { slidesPerView: 2 },
        480: {
          slidesPerView: 2.5,
          // scrollbar: { el: '.swiper-scrollbar', draggable: true },
        },
        767: {
          slidesPerView: 3,
          // scrollbar: { el: '.swiper-scrollbar', draggable: true},
        },
        1025: {
          slidesPerView: 4,
          // scrollbar: { el: '.swiper-scrollbar', draggable: true },
        },
      },
    });
  });
}

   function tabInitSection() {
    // Select all instances of the section on the page
    const sections = document.querySelectorAll('[id^="section-id-"]');

    sections.forEach((section) => {
      const tabs = section.querySelectorAll('.tab-nav a');
      const panes = section.querySelectorAll('.tab-pane');

      // Remove any existing event listeners to prevent duplication
      tabs.forEach((tab) => {
        tab.removeEventListener('click', handleTabClick);
        tab.addEventListener('click', handleTabClick);  
      });

      function handleTabClick(event) {
        event.preventDefault();

        // Clear active classes in the current section
        tabs.forEach((t) => t.classList.remove('active'));
        panes.forEach((p) => p.classList.remove('active'));

        // Activate clicked tab
        const targetPaneId = this.getAttribute('href');
        const targetPane = section.querySelector(targetPaneId);

        if (targetPane) {
          this.classList.add('active');
          targetPane.classList.add('active');
        }
      }

      // Activate the first tab by default
      if (tabs.length > 0) {
        tabs[0].click();
      }
    });
  }





    document.addEventListener('DOMContentLoaded', function (event) {
      tabInitSection();
      swiperSlider();
    });
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:section:unload', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:section:select', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:section:deselect', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:block:select', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:block:deselect', function (event) {
        tabInitSection();
        swiperSlider();
      });
    }